import { Component } from '@angular/core';
import { ButtonComponent } from './button.component';

@Component({
    selector: 'app-icon-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.scss']
})
export class IconButtonComponent extends ButtonComponent {
    constructor() {
        super();
        this.type = 'link';
        this.hostClass += ' icon-only-button';
        this.buttonClassesCallback = () => this.buttonClassSet.add('mx-auto').add('with-ripple');
    }
}
